import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  BOOL, CURRENCY, DATE, DATE_TIME, NUMBER, PICKLIST, STRING,
} from 'Consts/meta';
import { formatNumber } from 'Helpers/Meta';
import { withStyles } from '@material-ui/core/styles';
import Typography from 'Components/UI/Typography';
import moment from 'moment';
import { fullDate, fullDateTime } from 'Consts/DateFormats';
import { currency } from 'Helpers/Formats';

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1,
    flexFlow: 'column',
  },
  labelsAndValues: {
    display: 'flex',
    flexFlow: 'row',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  column: {
    display: 'flex',
    flexFlow: 'column',
    flex: 1,
    marginLeft: theme.spacing(2),
  },
  row: {
    display: 'flex',
    flexFlow: 'row',
    marginTop: theme.spacing(1),
  },
  prompt: {
    flex: 1,
    fontWeight: theme.typography.fontWeightBold,
  },
  value: {
    flex: 4,
    fontWeight: theme.typography.fontWeightMedium,
    paddingLeft: theme.spacing(1),
  },
});

const renderFieldValue = (resource, field) => {
  const name = field.attr('name');
  const value = resource.attr(name);
  const type = field.attr('type');
  const hint = field.attr('hint');
  switch (type) {
    case STRING || BOOL:
      if (hint === 'usd') {
        return currency(value, false);
      }
      if (Array.isArray(value) && value.length > 0) {
        return value.map(val => <p>{val}</p>);
      }
      if (!value || value === '') {
        return 'N/A';
      }
      return value;
    case DATE_TIME:
      return moment(value).utc().format(fullDateTime);
    case DATE:
      return moment(value).utc().format(fullDate);
    case NUMBER:
      if (hint === 'usd') {
        return currency(value, false);
      }
      return formatNumber(value, field);
    case CURRENCY:
      return currency(value, false);
    case PICKLIST:
      return resource.selectedOptionPrompt(name);
    default:
      return value;
  }
};

const MetaReadOnlyView = ({
  classes,
  className,
  resource,
  hiddenFields,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.labelsAndValues}>
        <div className={classes.column}>
          {resource.meta().template().list().filter(field => !field.attr('hidden') && !hiddenFields.includes(field.attr('name')))
            .map(field => (
              <div className={classes.row}>
                <Typography className={classes.prompt}>
                  {field.attr('prompt')}
                </Typography>
                <Typography className={classes.value}>
                  {renderFieldValue(resource, field)}
                </Typography>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

MetaReadOnlyView.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  resource: PropTypes.object.isRequired,
  hiddenFields: PropTypes.array,
};
MetaReadOnlyView.defaultProps = {
  className: '',
  hiddenFields: [],
};

export default withStyles(styles)(MetaReadOnlyView);
